import { CommandBarButton, IButtonProps } from '@fluentui/react'

import AddIcon from '../../assets/add-red.svg'
import HistoryIcon from '../../assets/history.svg'
import MagicAiIcon from '../../assets/magic-ai-icon.svg?react'

import { Button } from '@mui/material'
import { useState } from 'react'
import styles from './Button.module.css'

interface ButtonProps extends IButtonProps {
  onClick: () => void
  text: string | undefined
  large?: boolean
}

export const ShareButton: React.FC<ButtonProps> = ({ onClick, text }) => {
  return (
    <CommandBarButton
      className={styles.shareButtonRoot}
      iconProps={{ iconName: 'Share' }}
      onClick={onClick}
      text={text}
    />
  )
}

export const HistoryButton: React.FC<ButtonProps> = ({ onClick, text }) => {
  return (
    <Button
      onClick={onClick}
      className={styles.headerButton}
      size="small"
      startIcon={<img src={HistoryIcon} />}>
      {text}
    </Button>
  )
}

export const NewChatButton: React.FC<ButtonProps> = ({ onClick, text }) => {
  return (
    <Button
      onClick={onClick}
      className={styles.headerButton}
      size="small"
      startIcon={<img src={AddIcon} />}>
      {text}
    </Button>
  )
}

export const ActionButton: React.FC<ButtonProps & { template?: 'primary' | 'secondary' }> = ({
  onClick,
  text,
  template = 'primary',
  disabled = false,
  large = false,
  className,
}) => {
  return (
    <Button
      onClick={onClick}
      className={
        className
          ? className
          : template === 'primary'
            ? large
              ? styles.largePrimaryButton
              : styles.primaryButton
            : styles.secondaryButton
      }
      size="small"
      disabled={disabled}>
      {text}
    </Button>
  )
}

export const CreateExperimentButton: React.FC<ButtonProps> = ({
  onClick,
  text,
  disabled = false,
}) => {
  const [isPressed, setIsPressed] = useState(false)

  const handleMouseDown = () => {
    if (!disabled) setIsPressed(true)
  }

  const handleMouseUp = () => {
    setIsPressed(false)
  }

  const handleMouseLeave = () => {
    setIsPressed(false)
  }

  return (
    <Button
      onClick={onClick}
      className={`${styles.createExperimentButton} ${isPressed ? styles.createExperimentButtonPressed : ''}`}
      disabled={disabled}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseLeave}>
      <span className={`${styles.createExperimentButtonText} ${isPressed ? styles.createExperimentButtonTextPressed : ''}`}>
        {text}
      </span>
      <span className={styles.createExperimentButtonIcon}>
        <MagicAiIcon className={isPressed ? styles.createExperimentButtonIconGradient : ''} />
      </span>
    </Button>
  )
}
